// import { required, email } from 'vuelidate/lib/validators'

export default {

}



// WEBPACK FOOTER //
// ./src/app/professional/company/staffs/form/resources/validations.js